import React from "react";

import { Icon } from "@chakra-ui/react";
import {
  MdBarChart,
  MdPerson,
  MdHome,
  MdLock,
  MdOutlineShoppingCart,
} from "react-icons/md";

// Admin Imports
import MainDashboard from "views/admin/default";
import NFTMarketplace from "views/admin/marketplace";
import Profile from "views/admin/profile";
import DataTables from "views/admin/dataTables";
import RTL from "views/admin/rtl";

import AnalysisDiffer from "views/admin/analysisDiffer";
import AnalysisCluster from "views/admin/analysisCluster";
// import AnalysisSurvival from "views/admin/analysisSurvival";
import AnalysisGlycosylation from "views/admin/analysisGlycosylation";
import AnalysisSurvival from "views/admin/analysisSurvival";
import AnalysisPTMCrossTalk from "views/admin/analysisPTMCrossTalk";
import ProteinDetail from "views/admin/proteinDetail";

// Auth Imports
import SignInCentered from "views/auth/signIn";

const routes = [

  {
    name: "Main Dashboard",
    layout: "/admin",
    path: "/default",
    icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
    component: MainDashboard,
  },
  // {
  //   name: "NFT Marketplace",
  //   layout: "/admin",
  //   path: "/nft-marketplace",
  //   icon: (
  //     <Icon
  //       as={MdOutlineShoppingCart}
  //       width='20px'
  //       height='20px'
  //       color='inherit'
  //     />
  //   ),
  //   component: NFTMarketplace,
  //   secondary: true,
  // },
  {
    name: "Glycoprotein Table",
    layout: "/admin",
    icon: <Icon as={MdBarChart} width='20px' height='20px' color='inherit' />,
    path: "/data-tables",
    component: DataTables,
  },
  {
    name: "Protein Detail",
    layout: "/admin",
    path: "/detail/:id",  // :id is a route parameter
    icon: <Icon as={MdBarChart} width='20px' height='20px' color='inherit' />,
    component: ProteinDetail,
    hidden: true, // Add this property
  },
  {
    name: "Data Analysis",
    layout: "/admin",
    icon: <Icon as={MdBarChart} width='20px' height='20px' color='inherit' />,
    path: "/data-analysis",
    // collapse: true,
    // component: DataTables,
    subRoutes: [
      {
        name: "Differential Expression",
        layout: "/admin",
        path: "/data-analysis/differ",
        component: AnalysisDiffer, // Replace this with the actual component
      },
      {
        name: "Clustering",
        layout: "/admin",
        path: "/data-analysis/clustering",
        component: AnalysisCluster, // Replace this with the actual component
      },
      {
        name: "Survival",
        layout: "/admin",
        path: "/data-analysis/survival",
        component: AnalysisSurvival, // Replace this with the actual component
      },
      {
        name: "PTMCrossTalk",
        layout: "/admin",
        path: "/data-analysis/crosstalk",
        component: AnalysisPTMCrossTalk, // Replace this with the actual component
      },
      {
        name: "Glycosylation",
        layout: "/admin",
        path: "/data-analysis/glycosylation",
        component: AnalysisGlycosylation, // Replace this with the actual component
      }
    ]
  },
  
  // {
  //   name: "Profile",
  //   layout: "/admin",
  //   path: "/profile",
  //   icon: <Icon as={MdPerson} width='20px' height='20px' color='inherit' />,
  //   component: Profile,
  // },
  // {
  //   name: "Sign In",
  //   layout: "/auth",
  //   path: "/sign-in",
  //   icon: <Icon as={MdLock} width='20px' height='20px' color='inherit' />,
  //   component: SignInCentered,
  // },
  // {
  //   name: "RTL Admin",
  //   layout: "/rtl",
  //   path: "/rtl-default",
  //   icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
  //   component: RTL,
  // },
];

export default routes;
